import { type Context } from '@atlassian/surface-sdk/types';

import { createSessionId } from '../../utils/createSessionId';

import { isContextChanged } from './utils/isContextChanged';
import { mapSubproduct } from './utils/mapSubproduct';

export type ContextMiddleware = (context: Context) => Context;

const defaultsMiddleware: ContextMiddleware = (context) => context;

const createSessionIdMiddleware = (): ContextMiddleware => {
	let previousContext: Context;

	return (context) => {
		if (previousContext === undefined && context.sessionId) {
			previousContext = context;

			return context;
		}

		if (!context.sessionId || isContextChanged(previousContext, context)) {
			const newContext = { ...context, sessionId: createSessionId() };

			previousContext = newContext;

			return newContext;
		}

		return context;
	};
};

export const subProductMiddleware: ContextMiddleware = ({ subproduct, ...context }) => ({
	...context,
	subproduct: mapSubproduct(subproduct),
});

export const createContextMiddleware = (): ContextMiddleware => {
	/**
	 * Session id refers to a context session. When context changes the session will update
	 */
	const sessionIdMiddleware = createSessionIdMiddleware();

	return (context) => defaultsMiddleware(subProductMiddleware(sessionIdMiddleware(context)));
};
